import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { logout } from "@/lib/auth";

export function LogoutPage() {
  const navigate = useNavigate();
  useEffect(() => {
    (async () => {
      await logout();
      navigate("/", { replace: true });
    })();
  }, [navigate]);

  return (
    <div className="mx-auto mt-32 max-w-md px-4 text-center">
      <div className="mx-auto h-8 w-8 animate-spin rounded-full border-2 border-neutral-300 border-t-neutral-900" />
      <p className="mt-4 text-sm text-neutral-500">Signing out…</p>
    </div>
  );
}
